import { Anchor } from "@mantine/core";
import React from "react";
import { AppRoutes } from "@/constants.ts";

interface BrandedAnchorProps {
  businessSlug?: string;
  businessInfo?: { theme?: { primaryColor?: string } };
  label: string;
  href?: string;
  className?: string;
  align?: "left" | "center" | "right";

  [key: string]: any; // for other Anchor props
}

const getDefaultHref = (label: string, businessSlug?: string) => {
  const lower = label.toLowerCase();
  if (lower.includes("create account")) {
    return businessSlug
      ? `/${businessSlug}/register`
      : AppRoutes.gettingStarted;
  }
  if (lower.includes("forgot password")) {
    return businessSlug
      ? `/${businessSlug}/forgotpassword`
      : AppRoutes.forgotPassword;
  }
  if (lower.includes("login")) {
    return businessSlug ? `/${businessSlug}/login` : AppRoutes.login;
  }
  return "#";
};

const BrandedAnchor: React.FC<BrandedAnchorProps> = ({
  businessSlug,
  businessInfo,
  label,
  href,
  className,
  align = "center",
  ...rest
}) => {
  const color = businessInfo?.theme?.primaryColor || "#0077CC";
  const anchorHref = href || getDefaultHref(label, businessSlug);
  return (
    <Anchor
      href={anchorHref}
      c={color}
      ta={align}
      fz="14px"
      className={className}
      {...rest}
    >
      {label}
    </Anchor>
  );
};

export default BrandedAnchor;
